export const frontmatter = {
    "draft": false,
    "title": "Guide: Channels",
    "description": "How to create and configure channels in OnnIA: general data, business hours, and WhatsApp, WebChat, and API integrations.",
    "sidebar_label": "Channels",
    "sidebar_group": "reference",
    "sidebar_order": 4
}

export const toc = [
    {
        "depth": 2,
        "id": "module-access",
        "value": "Module access"
    },
    {
        "depth": 2,
        "id": "create-a-channel",
        "value": "Create a channel"
    },
    {
        "depth": 3,
        "id": "step-1-general-data",
        "value": "Step 1: General data"
    },
    {
        "depth": 3,
        "id": "step-2-business-hours",
        "value": "Step 2: Business hours"
    },
    {
        "depth": 3,
        "id": "step-3-integrations",
        "value": "Step 3: Integrations"
    },
    {
        "depth": 2,
        "id": "actions-on-existing-channels",
        "value": "Actions on existing channels"
    },
    {
        "depth": 2,
        "id": "recommendations",
        "value": "Recommendations"
    }
]